// src/utils/constants.ts - ФИНАЛЬНАЯ ВЕРСИЯ (ПРОМПТ 4/4)

// ========== ВАЛИДАЦИЯ ==========
export const MAX_PAST_DAYS_TO_MARK = 2; // Можно отметить: сегодня (0), вчера (1), позавчера (2)
export const VALIDATION_MESSAGE = 'Можно отметить только сегодня, вчера или позавчера';

// ========== ВАЛИДАЦИЯ ДАТ (Task 5) ==========
export const MAX_VALID_DATE = '2026-02-01'; // 1 февраля 2026 года - максимальная дата для календаря

// ========== MESSAGES (ЗАДАЧА #21) ==========
export const MESSAGES = {
  validation: {
    pastDays: 'Можно отметить только сегодня, вчера или позавчера',
    futureDay: 'День еще не наступил ⏰',
    notPlanned: 'День не запланирован',
    alreadyMarked: 'Этот день уже отмечен — отличный прогресс! 💜',
  },
  calendar: {
    syncing: 'Синхронизация...',
    syncError: 'Ошибка синхронизации',
  },
  profile: {
    copied: 'Скопировано в буфер обмена!',
    linkCopied: 'Реферальная ссылка скопирована!',
    resetConfirm: 'Вы уверены? Все данные будут удалены и придётся пройти анкету заново.',
  },
  auth: {
    unauthorized: 'Требуется повторная авторизация',
    loading: 'Подключаемся к вашему аккаунту...',
    error: 'Не удалось авторизоваться',
  },
};

// ========== LAYOUT (ЗАДАЧА #23) ==========
export const LAYOUT = {
  NAV_HEIGHT: 76,
  HEADER_HEIGHT: 60,
  BOTTOM_PADDING_BASE: 140,
  
  get CONTENT_MIN_HEIGHT() {
    return `calc(100vh - ${this.HEADER_HEIGHT}px)`;
  },
};

// ========== SPACING (ЗАДАЧА #23) ==========
export const SPACING = {
  section: 32,
  card: 16,
  element: 12,
  tiny: 8,
};

// ========== CONTAINER PADDING (ЗАДАЧА #23) ==========
export const CONTAINER_PADDING = {
  top: 24,
  horizontal: 16,
  bottom: 140, // 76px навигация + 64px запас
};

export const CONTAINER_PADDING_SMALL = {
  top: 20,
  horizontal: 12,
  bottom: 140,
};

// ========== TIMING ==========
export const TOAST_DURATION = 3200; // мс
export const ACHIEVEMENT_TOAST_DURATION = 5000; // мс
export const STAGE_MODAL_AUTO_CLOSE = 900; // мс

// ========== ДОСТИЖЕНИЯ ==========
export const EVENING_TIME_START = 18; // 18:00
export const EVENING_TIME_END = 23; // 23:00
export const MIN_EVENING_APPLICATIONS = 5;

// ========== FEEDBACK ==========
export const FEEDBACK_PROMPT_DAYS = 7; // Показывать каждые 7 дней
export const MIN_APPS_FOR_FEEDBACK = 3; // Минимум применений для показа